import {
  Bar,
  BarChart,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import {
  CHART_DEFAULT_DATA_KEY,
  CHART_DEFAULT_NAME_KEY,
  CHART_POINTER_EVENTS_PROPS,
  CHART_RESPONSIVE_CONTAINER_PROPS,
  PIE_CHART_COLORS,
} from '../Chart.constants'

import {
  BAR_CHART_DEFAULT_PROPS,
  BAR_CHART_TOOLTIP_DEFAULT_PROPS,
  BAR_CHART_X_AXIS_DEFAULT_PROPS,
  BAR_CHART_Y_AXIS_DEFAULT_PROPS,
  BAR_DEFAULT_PROPS,
  CHART_BAR_LAYOUT,
} from './ChartBar.constants'
import { checkIsChartBarColumns } from './ChartBar.utils'

function ChartBar({
  barProps = BAR_DEFAULT_PROPS,
  chartProps = BAR_CHART_DEFAULT_PROPS,
  color = PIE_CHART_COLORS[0],
  data = EMPTY_LIST,
  dataKey = CHART_DEFAULT_DATA_KEY,
  layout = CHART_BAR_LAYOUT.rows,
  nameKey = CHART_DEFAULT_NAME_KEY,
  tooltipProps = EMPTY_OBJECT,
  xAxisProps = BAR_CHART_X_AXIS_DEFAULT_PROPS,
  yAxisProps = BAR_CHART_Y_AXIS_DEFAULT_PROPS,
}) {
  return (
    <ResponsiveContainer {...CHART_RESPONSIVE_CONTAINER_PROPS}>
      <BarChart
        {...CHART_POINTER_EVENTS_PROPS}
        {...chartProps}
        data={data}
        layout={layout}
      >
        {checkIsChartBarColumns(layout) ? (
          <>
            <XAxis {...xAxisProps} dataKey={nameKey} type='category' />
            <YAxis hide type='number' />
          </>
        ) : (
          <>
            <XAxis hide type='number' />
            <YAxis {...yAxisProps} dataKey={nameKey} type='category' />
          </>
        )}
        <Tooltip {...BAR_CHART_TOOLTIP_DEFAULT_PROPS} {...tooltipProps} />
        <Bar {...barProps} dataKey={dataKey} fill={color}>
          {data.map(item => (
            <Cell fill={item.color ?? color} key={item.id ?? item[nameKey]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  )
}

export default ChartBar
